import { createContext, Dispatch, SetStateAction } from 'react';

interface SelectedItemsCtx {
  selectedItemsContext: any[];
  setSelectedItemsContext: Dispatch<
    SetStateAction<SelectedItemsCtx['selectedItemsContext']>
  >;
}

// SelectedItemsContext is a placeholder for the selected
// files that the user has seleced (checked) from the table
const SelectedItemsContext = createContext({
  selectedItemsContext: [],
  setSelectedItemsContext: () => [],
} as SelectedItemsCtx);

export default SelectedItemsContext;
